module.exports = __webpack_public_path__ + "e4194f88fa23206cee05e5517cf705e2.MP3";